var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackageThreeMonths(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-3{fill:#f9dd29;}.cls-2{opacity:0.3;}.cls-4{mix-blend-mode:multiply;}.cls-5{fill:#e7b142;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tavola disegno 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -4.43,
    y: -10,
    width: 808.85,
    height: 820
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M255.23,50.51Q331-10,454.29-10q58.82,0,104.05,14.14t75.22,38.45q30,24.32,45.24,57.69A167.85,167.85,0,0,1,694.07,171a189.27,189.27,0,0,1-10.75,63.33,183.58,183.58,0,0,1-31.66,56q-20.92,25.45-51.47,44.11T528.94,361v3.39Q596.8,383.6,631.3,432.23t34.49,108.58q0,62.22-22,112a243.78,243.78,0,0,1-61.64,84.82q-39.58,35.07-93.88,53.73T368.33,810q-66.74,0-115.93-18.1t-82-49.2a192.14,192.14,0,0,1-48.63-74.08q-15.84-43-15.84-92.74V564.57a124.62,124.62,0,0,1,1.13-14.71H284.63a69.83,69.83,0,0,0-1.13,10.75v8.48q0,38.46,24.89,61.64t64.47,23.19q48.63,0,73.51-31.67t24.89-73.52a137.26,137.26,0,0,0-5.09-37.32,74.16,74.16,0,0,0-18.1-31.67q-13-13.58-34.5-21.49t-53.16-7.92H329.88L352.5,302.17h35.06q53.16,0,83.13-24.89t30-64.47q0-30.52-19.23-48.63t-48.63-18.1q-32.81,0-56,19.8t-31.1,59.38H168.14Q179.45,111,255.23,50.51Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M207.48,529.88l6.85-109.31q.39-5.71.95-12.95c.39-4.83.83-9.71,1.34-14.67s.95-9.71,1.33-14.28.83-8.5,1.33-11.81h-1.52q-1.9,5.34-4.76,12.95t-6.29,15.24q-3.42,7.62-6.47,14.47t-4.57,11.05L149.58,529.88H106.17L94.36,420.19q-.77-8.76-2.48-24t-2.47-29.33H87.88Q86,377.92,82.74,393.14t-6.28,26.28L47.89,529.88H-10L60.84,270.12h64.75l14.85,96q1.91,11.43,3.43,24.19t2.29,23.42h1.52q4.19-10.66,9.71-24.18t10.1-23.43l43.8-96h67.79l-8.76,259.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M395.62,328.4l-6.48,40.37h88l-8.38,54.46h-88l-7.61,48.37H468l-9.14,58.28H298.5l41.13-259.76H496.17l-9.52,58.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M624.71,322.68a23.55,23.55,0,0,0-15.81-6.09q-10.27,0-16.75,5.9t-6.48,16.57a21.77,21.77,0,0,0,7.24,16.38q7.23,6.85,19.8,12.95Q647,384.77,661.85,405t14.85,48.37q0,20.19-6.86,36A74.11,74.11,0,0,1,650.61,516a84.81,84.81,0,0,1-29.52,16.57,118.55,118.55,0,0,1-37.7,5.72,120.21,120.21,0,0,1-34.85-4.77,71.19,71.19,0,0,1-27.61-15.42q-11.82-10.67-19.24-27.42t-9.33-40.76h65.51q0,17.52,8.76,25.52a30,30,0,0,0,21,8q11.42,0,18.28-7.05t6.85-17.71q0-10.27-7.23-19t-25.9-17.52q-30.09-14.47-44-34.85T521.69,341a77.82,77.82,0,0,1,6.47-31.81A74.48,74.48,0,0,1,546.06,284a82.39,82.39,0,0,1,27.23-16.38,97.69,97.69,0,0,1,34.47-5.91q40,0,63.23,21.52t25.52,58.47h-64Q631.76,328.77,624.71,322.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M810,270.12,768.87,529.88H703.36l41.13-259.76Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageThreeMonths);
export default __webpack_public_path__ + "static/media/packageThreeMonths.2fccdec48bb76d9e695280271bad2908.svg";
export { ForwardRef as ReactComponent };